import { render, staticRenderFns } from "./TestGroup.vue?vue&type=template&id=596fd2c2&scoped=true"
import script from "./TestGroup.vue?vue&type=script&lang=js"
export * from "./TestGroup.vue?vue&type=script&lang=js"
import style0 from "./TestGroup.vue?vue&type=style&index=0&id=596fd2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596fd2c2",
  null
  
)

export default component.exports